import { injectable, inject } from 'inversify';
import { UnitOptionChangeProfil } from '@Models';
import { unit_option_change_profil } from '@Api';
import { ModelRuleChangeProfilMapper } from './ModelRuleChangeProfilMapper';
import { TYPES } from '@Types';

@injectable()
export class UnitOptionChangeProfilMapper {
  @inject(TYPES.Mapper.ModelRuleChangeProfilMapper)
  private readonly _modelRuleChangeProfilMapper!: ModelRuleChangeProfilMapper;

  public map(item: unit_option_change_profil): UnitOptionChangeProfil {
    return {
      action: this._modelRuleChangeProfilMapper.mapAction(item.action),
      troopId: item.troop_id,
      caracs: this._modelRuleChangeProfilMapper.mapCarac(item.caracs),
      value: item.value,
    } satisfies UnitOptionChangeProfil as UnitOptionChangeProfil;
  }
}
